import { MdImage, MdAdd, MdEmail, MdPerson } from 'react-icons/md';
import React from 'react';
import styles from './ProductTypes.module.css';
import SpecialCard from 'components/common/SpecialCard/SpecialCard';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ProductTypes = ({ handleProductTypeSelect, handleAddNewDialog, currentModifiers }) => {
  const { t } = useTranslation();
  const SpecialIcon = (isEnabled) => {
    return (
      <div className={styles.special_icon}>
        <MdPerson size={'75px'} color={isEnabled ? 'var(--primary-background-primary)' : '#8a8888'} />
        <div className={styles.small_icon}>
          <MdImage size={'30px'} color={isEnabled ? 'var(--primary-background-primary)' : '#8a8888'} />
        </div>
      </div>
    );
  };

  return (
    <SpecialCard title={t('templates.editProductTypes')} sx={styles.left}>
      <div className={styles.productTypeContainer}>
        {currentModifiers?.map((el) => {
          if (el.priority === 1) {
            const isEnabled = currentModifiers?.find((mod) => mod.id === el.id)?.enabled;

            return (
              <Tooltip
                title={
                  el.deliveryTypeDTO === 'POST'
                    ? t('templates.postDelivery')
                    : el.deliveryTypeDTO === 'EMAIL'
                    ? t('templates.emailDelivery')
                    : t('templates.ownDelivery')
                }>
                <div
                  key={el.id}
                  className={`${styles.card} ${isEnabled ? styles.cardEnabled : ''}`}
                  onClick={() => handleProductTypeSelect(el)}>
                  <div>
                    {el.deliveryTypeDTO === 'POST' ? (
                      <MdImage size={'75px'} color={isEnabled ? 'var(--primary-background-primary)' : '#8a8888'} />
                    ) : el.deliveryTypeDTO === 'LELKES_SELF_PRINT' ||
                      el.deliveryTypeDTO === 'SELF' ||
                      el.deliveryTypeDTO === 'POST_AND_LELKES_PRINT' ? (
                      <SpecialIcon isEnabled={isEnabled} />
                    ) : (
                      <MdEmail size={'75px'} color={isEnabled ? 'var(--primary-background-primary)' : '#8a8888'} />
                    )}
                  </div>
                  <div>
                    {el.deliveryTypeDTO === 'POST'
                      ? t('methodChooser.printed')
                      : el.deliveryTypeDTO === 'EMAIL'
                      ? t('methodChooser.digital')
                      : el.name}
                  </div>
                </div>
              </Tooltip>
            );
          }
          return null;
        })}
        <div className={styles.card} onClick={handleAddNewDialog}>
          <MdAdd size={'100px'} />
        </div>
      </div>
    </SpecialCard>
  );
};

export default ProductTypes;
